import React, { useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import { forwardRef } from 'react';
import { getUuid } from '@front10/helpers/dist/uuid';

import Box from '../Box';
import { StyledProps, CSSProperties } from '@front10';
import Text from '../../elements/Text';
import Icon from '../../elements/Icon';

export interface Props {
  forwardedRef?: any;
  refInput?: any;
  isChecked?: boolean;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
  onChange?: (e: any) => void;
  label?: string;
  optionStyles?: StyledProps<$TSFixMe>;
  labelStyles?: StyledProps<$TSFixMe>;
  tabIndex?: number;
  name?: string;
}

function Checkbox(props: Props) {
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const id = getUuid();
  return (
    <Box display="flex" alignItems="center" className={`${className}`} style={style}>
      <Text className="fr-input-checkbox-container" {...props.optionStyles}>
        <input
          ref={props.refInput}
          id={`checkbox-input${id}`}
          name={props.name}
          className="fr-input-checkbox"
          type="checkbox"
          checked={props.isChecked}
          onChange={props.onChange}
          disabled={props.disabled}
          onBlur={() => {
            if (
              props.forwardedRef !== null &&
              props.forwardedRef !== undefined &&
              props.forwardedRef.current !== undefined &&
              props.forwardedRef.current !== null
            ) {
              props.forwardedRef.current.focus();
            }
          }}
        />
        <Icon icon="checkbox" viewBox="0 0 24 24" size={24} />
        <Icon icon="checkbox-outline" viewBox="0 0 24 24" size={24} />
      </Text>
      <Text {...props.labelStyles} textAlign="left" type="label" htmlFor={`checkbox-input${id}`}>
        {props.label}
      </Text>
    </Box>
  );
}

Checkbox.defaultProps = {
  isChecked: false,
  onChange: () => {}
};

Checkbox.componentName = 'Checkbox';
export default forwardRef((props: Props, ref: any) => <Checkbox forwardedRef={ref} {...props} />);
